import React from 'react'
import './Header.css'

export default function Header(props) {
    return(
        <div className='header' ref={props.refer}>
            <img src={props.src} alt=''/>
            <h1>{props.text}</h1>
        </div>
    )
}